export enum CommunicationShortcut {
    ShortcutLinkNotifyUsers = 'ShortcutLinkNotifyUsers',
    ShortcutLinkAttachments = 'ShortcutLinkAttachments',
    ShortcutLinkSurveys = 'ShortcutLinkSurveys',
    ShortcutLinkDeclarations = 'ShortcutLinkDeclarations'
  }
